/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Tool_Bulk_Count_UpdatesInputs */



/**
* | output |
* | --- |
* | "{count} updates" |
*
* @param {Chat_Tool_Bulk_Count_UpdatesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_bulk_count_updates = /** @type {((inputs: Chat_Tool_Bulk_Count_UpdatesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Bulk_Count_UpdatesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Aktualisierungen`)
	return /** @type {LocalizedString} */ (`${i?.count} updates`)
});